import { Component, OnInit, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
// import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
declare var $: any;

@Component({
  selector: "app-reg",
  templateUrl: "./reg.component.html",
  styleUrls: ["./reg.component.css"],
})
export class RegComponent implements OnInit {
  focus;
  focus1;
  focus2;
  name;
  email;
  username;
  password;

  test: Date = new Date();
  private toggleButton;
  private sidebarVisible: boolean;
  private nativeElement: Node;

  constructor(
    private http: HttpClient,
    private router: Router,
    private element: ElementRef
  ) {
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  ngOnInit() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.add("login-page");
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName("navbar-toggle")[0];

    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      $(".card").removeClass("card-hidden");
    }, 700);
  }
  ngOnDestroy() {
    var body = document.getElementsByTagName("body")[0];
    body.classList.remove("login-page");
  }
  sidebarToggle() {
    var toggleButton = this.toggleButton;
    var body = document.getElementsByTagName("body")[0];
    var sidebar = document.getElementsByClassName("navbar-collapse")[0];
    if (this.sidebarVisible == false) {
      setTimeout(function () {
        toggleButton.classList.add("toggled");
      }, 500);
      body.classList.add("nav-open");
      this.sidebarVisible = true;
    } else {
      this.toggleButton.classList.remove("toggled");
      this.sidebarVisible = false;
      body.classList.remove("nav-open");
    }
  }

  submitm() {
    console.log(this.name, this.email, this.username, this.password);
    var url = environment.apiURL + "regm/";
    var body = new FormData();
    body.append("name", this.name);
    body.append("email", this.email);
    body.append("username", this.username);
    body.append("password", this.password);

    this.http.post<any>(url, body).subscribe(
      (data) => {
        console.log(data);
        alert("success");
        this.router.navigateByUrl("/root/log");
      },
      (err) => {
        console.log("some error occured contact admin");
        alert("username already exist");
      }
    );
  }
}
